import React from "react";
import {observer} from "mobx-react";
import {GamesOpenSessionRecordContentContainerBox} from "./boxes/container/games-open-session-record-content-container.box";
import {IGameOpenSessionViewModel} from "../../../../services/games-open-sessions/games-open-session.service.interface";
import {GamesOpenSessionRecordGameIconBox} from "./boxes/game-icon/games-open-session-record-game-icon.box";
import {Image} from "../../../raw-components/image/image";
import {GamesOpenSessionRecordSessionDetailsBox} from "./boxes/details/games-open-session-record-session-details.box";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {GamesOpenSessionRecordFieldsGridBox} from "./boxes/fields-grid/games-open-session-record-fields-grid.box";
import {
    GamesOpenSessionRecordGameIconContainerBox
} from "./boxes/game-icon/games-open-session-record-game-icon-container.box";
import {CyClass} from "../../../../../common/cy-classes";
import {GamesOpenSessionRecordFieldComponent} from "./games-open-session-record-field.component";
import {GamesOpenSessionPlayButtonComponent} from "./games-open-session-play-button.component";
import {GameInfo} from "../../../../services/games/game-info";
import {GamesOpenSessionRecordDateComponent} from "./games-open-session-record-date.component";

export const GamesOpenSessionRecordContentComponent: React.FC<{openSession: IGameOpenSessionViewModel; gameInfo: GameInfo}> = observer((props) => {
    const services = useServices();


    const isSmallScreen = services.mediaQuery.lAndBelow;


    return (
        <GamesOpenSessionRecordContentContainerBox className={CyClass('cy-open-session-record-content')}>
            <GamesOpenSessionRecordGameIconContainerBox>
                <GamesOpenSessionRecordGameIconBox>
                    <Image src={props.gameInfo.gameImageInHistoryPage}
                           fallbackSrc={props.gameInfo.getGameImagePlaceHolderUrl(false)}/>
                </GamesOpenSessionRecordGameIconBox>
                {!isSmallScreen && <GamesOpenSessionRecordDateComponent openSession={props.openSession}/>}
            </GamesOpenSessionRecordGameIconContainerBox>


            <GamesOpenSessionRecordSessionDetailsBox>
                {isSmallScreen && <GamesOpenSessionRecordDateComponent openSession={props.openSession}/>}
                <GamesOpenSessionRecordFieldsGridBox className={CyClass('cy-open-session-fields-grid')}>
                    <GamesOpenSessionRecordFieldComponent label={services.translation.translate('GAMING_HISTORY_BET')}
                                                          value={services.currency.formatMoney(props.openSession.credit)}/>

                    <GamesOpenSessionRecordFieldComponent label={services.translation.translate('OPEN_SESSION_STATUS_LABEL')}
                                                          value={services.translation.translate('OPEN_SESSION_STATUS_PENDING')}/>

                </GamesOpenSessionRecordFieldsGridBox>

                <GamesOpenSessionPlayButtonComponent gameInfo={props.gameInfo}/>

            </GamesOpenSessionRecordSessionDetailsBox>

        </GamesOpenSessionRecordContentContainerBox>
    )
})